"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var AppSwitcherFooter = function AppSwitcherFooter(_ref) {
  var onLinkClick = _ref.onLinkClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "app-switcher-footer"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://solarwinds.cloud",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onLinkClick
  }, "Read more about the SolarWinds Application Management Suite"));
};

var _default = AppSwitcherFooter;
exports["default"] = _default;